





































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import axios from 'axios';
import env from '@/env';
import { Wave } from '@/interfaces/Wave';

@Component({})
export default class ApplyToExistingDialog extends Vue {
  private dialog = false;

  @Watch('dialog')
  watchDialog(value: boolean) {
    if (value) this.loadCutoverplanList();
  }

  private cutoverplans: Cutoverplan[] = [];

  private selectedCutoverplanId = 0;

  private waves: Wave[] = [];

  async loadCutoverplanList() {
    const { data: waves } = await axios.get(`${env.backend_url}/all_waves`);
    const { data: cutoverplans } = await axios.get(`${env.backend_url}/all_cutoverplans`);
    this.cutoverplans = cutoverplans;
    this.waves = waves;
  }

  cutoverplansWithWave(id: number | null) {
    return this.cutoverplans.filter((cutoverplan) => cutoverplan.wave_id === id);
  }

  submit() {
    this.dialog = false;
    this.$emit('submit', this.selectedCutoverplanId);
  }

  getWaveName(wave: Wave) {
    const preferredLanguage = wave.waveLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    if (preferredLanguage) return preferredLanguage.name;
    return wave.waveLanguages?.[0]?.name;
  }
}
